// extracted by mini-css-extract-plugin
export default {"tools":"SubscriptionsModule_tools__JCgWO"};